import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromLaunchContext from "../reducers/launch-context.reducer";

export const launchContextState = createSelector(
    fromFeature.getLaunchContextState,
    (state: fromFeature.LaunchState) => state?.launchContext
);

export const getLaunchContext = createSelector(
    launchContextState,
    fromLaunchContext.getLaunchContext
);

